import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import parse from 'html-react-parser'
import { getTextShort, getDateTime, getFeatured } from '@helpers/helper.novelty'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
} from 'react-share'
import { makeShareUrl } from '@helpers/helper.rendering'
import { useLocation } from '@reach/router'
import ImageGallery from 'react-image-gallery'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'

const MOCKDATA = {
  noveltyCard: '1',
}

interface ExternalProps {
  id: string
  detail?: any // TODO: Fix this type
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const isBrowser = typeof window !== 'undefined'

const Detail_Novelty_2 = (props: CombinedProps) => {
  const { isDemo, global_data } = props
  const { divisionPath, id: siteId } = global_data
  const { noveltyCard } = isDemo
    ? MOCKDATA
    : { noveltyCard: global_data.content?.cardsNovelties?.type_id ?? '1' }

  const BlogDetailData = props.detail
  const isLoadingDetailData = false

  const imagesToShow = BlogDetailData?.images_data?.map(
    (image: {
      original: string
      thumbnail: string
      description: string
      text_alt: string
      file: string
    }) => ({
      original: image.file,
      thumbnail: image.file,
      description: image.text_alt,
      text_alt: image.text_alt,
    }),
  )

  const { data: allBlogData, isLoading: isLoadingBlogData } = useGetBlogsQuery({ site: siteId })
  const iconsStyle = 'solid'
  const location = useLocation()

  const Card = require(`@components/cardsNovelties/${noveltyCard}`)?.default

  const formateMessage = (str: string) => {
    return encodeURIComponent(str)
      .replace(/[!'()]/g, escape)
      .replace(/\*/g, '%2A')
  }

  useEffect(() => {
    if (BlogDetailData) {
      if (isBrowser) {
        window.scrollTo(0, 0)
      }
    }
  }, [BlogDetailData])

  // Avoid show duplicated novelties
  const avoidDuplicatedNov = (actualNovelty: Novelty | undefined, allNovelties: Novelty[]) => {
    if (actualNovelty) {
      return allNovelties?.filter((n) => actualNovelty?.id !== n?.id)
    }
    return []
  }

  function backToNovelties(e: any): void {
    e.preventDefault() + navigate((divisionPath ?? '') + '/novedades') // TODO: Hardcoded dynamic path?
  }

  return (
    <section className="novelty novelty-detail p-y-config b">
      <div className="container-fluid">
        <div className="row">
          <div className="first_div col-12 col-lg-8">
            {isLoadingDetailData ? (
              <>
                <div className="d-block d-lg-none"></div>
                <div className="d-none d-lg-block"></div>
              </>
            ) : (
              <>
                <div className="col-12"></div>
                <div className="div_header_novelty col-12 col-lg-12 pe-lg-5">
                  <span className="date mb-3 d-flex justify-content-end">
                    {getDateTime(BlogDetailData?.date_published, false, true)}
                  </span>
                  <img
                    className="pt-0 pt-lg-0 mb-4 mb-lg-3 image-novelty image-br-config"
                    src={BlogDetailData?.image}
                    alt=""
                  />
                  <div className="d-flex w-100 justify-content-end">
                    <span className="legend">{BlogDetailData?.footer || ''}</span>
                  </div>
                  <h1 className="title mt-lg-4 mt-4">{BlogDetailData?.title}</h1>
                  <h2 className="subtitle mt-4 mb-lg-5 mb-5">
                    {getTextShort(BlogDetailData?.headline, 500)}
                  </h2>
                  {BlogDetailData?.author && (
                    <span className="legend top">Publicado por {BlogDetailData?.author}</span>
                  )}
                </div>
                <div className="col-12 col-lg-12 pe-lg-5 div_body_novelty mt-lg-4 mt-4">
                  {BlogDetailData?.content ? <div> {parse(BlogDetailData?.content)}</div> : ''}
                </div>
                <div className="div_gallery mt-5 col-12 col-lg-12 pe-lg-5">
                  {!!imagesToShow?.length && (
                    <ImageGallery
                      showPlayButton={false}
                      showIndex
                      showBullets
                      autoPlay
                      items={imagesToShow}
                    />
                  )}
                  {!!BlogDetailData?.files_data?.length ? (
                    <div className="div_header_novelty mt-5">
                      <h2 className="subtitle">Archivos para descargar</h2>
                      <div className="with-bt" />
                      {BlogDetailData?.files_data?.map((files: any) => (
                        <div
                          key={files.id}
                          className="linkStyled"
                        >
                          <a
                            href={files.file}
                            className="download_link"
                          >
                            <i
                              className={`icon-download${iconsStyle} me-2 download_icon`}
                              style={{ fontSize: '1.5rem' }}
                            ></i>
                            {files.file
                              .substring(files.file.indexOf('news/'), files.file.length)
                              .substring(5)}
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    []
                  )}
                </div>
                <div className="div_footer_novelty col-12 col-lg-12 pe-lg-5">
                  <div className="d-lg-flex align-items-start justify-content-between with-bt">
                    <div className="div_pills d-flex flex-wrap">
                      <span className="me-lg-4 mb-3 me-3 w-100 d-block d-lg-none text-center">
                        Etiquetas de filtrado:{' '}
                      </span>
                      <div className="d-flex flex-wrap flex-row mx-auto justify-content-center justify-content-lg-start">
                        {BlogDetailData?.tags?.map((tag: TagMediacore, index: number) => (
                          <span
                            key={index}
                            className="pill btn btn-primary me-2 mt-2 mb-lg-2 mt-lg-0"
                          >
                            {tag.name}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="d-lg-flex me-2 me-lg-0 mt-3 mb-lg-0 mt-lg-5 py-lg-2 py-3 shared-buttons mb-auto justify-content-center align-items-center">
                      <span className="me-lg-0 mb-lg-0 mb-3 me-3">Compartir: </span>
                      <div className="d-flex justify-content-center justify-content-lg-start">
                        <a
                          className="mx-1 WhatsappShareButton ms-2 me-0 ms-lg-3"
                          href={
                            'https://api.whatsapp.com/send?text=' +
                            formateMessage(
                              BlogDetailData?.title +
                                ': ' +
                                makeShareUrl({
                                  novelty: BlogDetailData,
                                  href: location?.href,
                                }),
                            )
                          }
                          target="_blank"
                        >
                          <WhatsappIcon
                            size={28}
                            bgStyle={{ fill: '#6b6b6b' }}
                          />
                        </a>
                        <EmailShareButton
                          className="mx-1 EmailShareButton ms-2 me-0 ms-lg-3"
                          body={
                            BlogDetailData?.title +
                            ' ' +
                            makeShareUrl({
                              novelty: BlogDetailData,
                              href: location?.href,
                            })
                          }
                          subject={BlogDetailData?.title}
                          url={''}
                        >
                          <EmailIcon
                            size={28}
                            bgStyle={{ fill: '#6b6b6b' }}
                          />
                        </EmailShareButton>
                        <FacebookShareButton
                          className="mx-1 FacebookShareButton ms-2 me-0 ms-lg-3"
                          url={makeShareUrl({
                            novelty: BlogDetailData,
                            href: location?.href,
                          })}
                          quote={BlogDetailData?.title}
                        >
                          <FacebookIcon
                            size={28}
                            bgStyle={{ fill: '#6b6b6b' }}
                          />
                        </FacebookShareButton>
                        <TwitterShareButton
                          className="mx-1 TwitterShareButton ms-2 me-0 ms-lg-3"
                          url={makeShareUrl({
                            novelty: BlogDetailData,
                            href: location?.href,
                          })}
                          title={BlogDetailData?.title}
                        >
                          <i className={`icon-twitter twitterCustomIcon`} />
                        </TwitterShareButton>
                        <LinkedinShareButton
                          url={makeShareUrl({
                            novelty: BlogDetailData,
                            href: location?.href,
                          })}
                          source={makeShareUrl({
                            novelty: BlogDetailData,
                            href: location?.href,
                          })}
                          title={BlogDetailData?.title}
                          className="mx-1 LinkedinShareButton ms-2 me-0 ms-lg-3"
                        >
                          <LinkedinIcon
                            size={28}
                            bgStyle={{ fill: '#6b6b6b' }}
                          />
                        </LinkedinShareButton>
                      </div>
                    </div>
                  </div>
                  <div className=" col-12 mt-5 text-center text-lg-start">
                    <a
                      onClick={(e) => backToNovelties(e)}
                      className="btn btn-primary"
                    >
                      Volver a las novedades
                    </a>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className={
              'second_div col-12 col-lg-4 ' +
              (getFeatured(allBlogData?.news)?.length === 0 && !isLoadingBlogData ? 'nothing' : '')
            }
          >
            <div className="container-fluid pt-0">
              <div className="row text-center">
                <h2 className="mb-3 title-row">
                  {getFeatured(allBlogData?.news)?.length === 0 && !isLoadingBlogData
                    ? ''
                    : 'Novedades destacadas'}
                </h2>
                <div className="col-12">
                  {isLoadingBlogData
                    ? [1, 2, 3].map((element) => (
                        <div
                          key={element}
                          className="mb-3"
                        ></div>
                      ))
                    : avoidDuplicatedNov(BlogDetailData, getFeatured(allBlogData?.news)!).map(
                        (novelty, index) => (
                          <div
                            key={index}
                            className="col-12 mb-4"
                          >
                            <Card
                              novelty={novelty}
                              hidenTags={true}
                              hidenAuthor={true}
                              global_data={global_data}
                              forceSquare={true}
                            />
                          </div>
                        ),
                      )}
                </div>
                {/* <div className='col-12 mb-4'>
                      <NoveltyCard hidenTags={true}/>
                  </div>
                  <div className='col-12 mb-4'>
                      <NoveltyCard hidenTags={true}/>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Detail_Novelty_2
